export default "__VITE_ASSET__61e312a2__"